import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'camelToKebabCase' })
export class CamelToKebabCasePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }
}
